import React from 'react';
import { connect } from 'react-redux';
import { HashRouter } from 'react-router-dom';

import { MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { RouterHooksContainer } from '~src/root/hooks/RouterHooksContainer';

import { AppState } from '../redux/state/AppState';
import { ConnectedRootSpace } from './RootSpace';

export interface RootSpaceRouterOwnProps {}
export interface RootSpaceRouterStateProps {
  readonly routerReactKey: number;
}
export type RootSpaceRouterProps = RootSpaceRouterOwnProps & RootSpaceRouterStateProps;

export class RootSpaceRouterComponent extends React.PureComponent<RootSpaceRouterProps> {
  public render() {
    return (
      <HashRouter key={'root-space-router-' + this.props.routerReactKey}>
        <RouterHooksContainer>
          <ConnectedRootSpace />
        </RouterHooksContainer>
      </HashRouter>
    );
  }
}

const mapStateToProps: MapStateToProps<RootSpaceRouterStateProps> = (state: AppState) => ({
  routerReactKey: state.routerSpaceReactKey
});

export const RootSpaceRouter: React.ComponentClass<RootSpaceRouterOwnProps>
  = connect(mapStateToProps, null, null, {pure: false})(RootSpaceRouterComponent);
